import styled from 'styled-components'

export const MainLayout = styled.div`
  position: fixed;
  display: flex;
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
`
